import React, { useRef, useEffect, useState, useContext, useCallback } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
// import { AppContext } from '../../Context/AppContext'
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";

import FinalizeEditedInvoices from "./FinalizeEditedInvoices";

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  clearInputBtn: {
    fontSize: ".8em",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1em",
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {},
  },
  grow: {
    flexGrow: 1,
  },
  productListPaper: {
    marginBottom: 50,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "right",
    color: theme.palette.text.secondary,
  },
}));

const materialTheme = createTheme({
  // set default for now
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const filter = createFilterOptions();

export default function EditSalesInvoiceSummary(props) {
  const classes = useStyles();
  // PRODUCTS
  const [invoicedProducts, setInvoicedProducts] = useState(props.selectedInvoices.InvoiceItems);
  const [loadProducts, setLoadProducts] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchProductTerm, setSearchProductTerm] = useState({ name: "" });
  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");

  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [openLotNumberAndExpirationDialogInput, setOpenLotNumberAndExpirationDialogInput] =
    useState(true);
  const [selectedProductForLotNumberInput, setSelectedProductForLotNumberInput] = useState(null);

  const [totalInvoicedAmount, setTotalInvoicedAmount] = useState(0);
  const [invoicedItemCount, setInvoicedItemCount] = useState(
    props.selectedInvoices.InvoiceItems.length
  );

  const [autoSuggestProducts, setAutoSuggestProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [hasMoreProductToLoad, setHasMoreProductToLoad] = useState(true);
  const lastProductElementObserver = useRef();

  const [openFinalizeProductDialog, setOpenFinalizeProductDialog] = useState(false);

  useEffect(() => {
    if (props.openEditInvoiceDialog === false) {
      return;
    }

    const createProductElementBasedOnProps = () => {
      const unique_products = [
        ...new Map(
          props.selectedInvoices.InvoiceItems.map((item) => [item.product_code, item])
        ).values(),
      ];

      const updatedProducts = unique_products.map((product) => {
        const units = props.selectedInvoices.InvoiceItems.filter(
          (items) => items.product_code === product.product_code
        );

        return {
          account_code: props.selectedInvoices.account_code,
          account_name: props.selectedInvoices.account_name,
          invoice_number: props.selectedInvoices.invoice_number,
          invoice_date: props.selectedInvoices.invoice_date,
          scheduled_delivery_date: props.selectedInvoices.scheduled_delivery_date,
          salesman_first_name: props.selectedInvoices.salesman_first_name,
          salesman_last_name: props.selectedInvoices.salesman_last_name,
          salesman_middle_name: props.selectedInvoices.salesman_middle_name,
          product_name: product.product_name,
          auto_generated_invoice_number: product.auto_generated_invoice_number,
          image: product.image,
          product_code: product.product_code,
          Units: units, // Add the new "units" property
        };
      });

      setTotalInvoicedAmount(computeTotalInvoiceAmount(updatedProducts));
      setInvoicedProducts(updatedProducts);
    };

    createProductElementBasedOnProps();
  }, [props.openEditInvoiceDialog]);

  const lastProductElement = useCallback(
    (node) => {
      if (isLoading) {
        return;
      }
      if (lastProductElementObserver.current) {
        lastProductElementObserver.current.disconnect();
      }
      lastProductElementObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreProductToLoad) {
          lastProductElementObserver.current.disconnect();
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
          setLoadProducts(true);
        }
      });

      if (node) {
        lastProductElementObserver.current.observe(node);
      }
    },
    [isLoading]
  );

  function search() {
    return (
      <div
        position="static"
        style={{
          border: ".1rem solid #989898",
          borderRadius: "4px",
          margin: "2px",
        }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                setInvoicedProducts([]);
                setPageNumber(1);
                setLoadProducts(true);
                //fetchProducts(searchProductTerm.name)
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }

  function autoComplete() {
    return (
      <Autocomplete
        value={searchProductTerm}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue == null || newValue.name === "") {
            //searchProductTerm.name = ""
            setSearchProductTerm({ name: "" });
            return;
          }
          //searchProductTerm.name = newValue.name
          setSearchProductTerm({ name: newValue.name });

          setInvoicedProducts([]);
          setPageNumber(1);
          setLoadProducts(true);

          //fetchProducts(newValue.name)
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestProducts}
        getOptionLabel={(option) => {
          return option.name;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name}>
              {option.name}
            </li>
          );
        }}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchProductTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }

  function productLists() {
    return (
      <List>
        {invoicedProducts.map((product, index) =>
          invoicedProducts.length === index + 1 ? (
            <React.Fragment key={product.id}>
              <ListItem ref={lastProductElement} divider>
                {productElement(product)}
              </ListItem>
            </React.Fragment>
          ) : (
            <React.Fragment key={product.id}>
              <ListItem divider>{productElement(product)}</ListItem>
            </React.Fragment>
          )
        )}
      </List>
    );
  }

  function orderInput(product, unit) {
    return (
      <div>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            <Grid container spacing={1}>
              <Grid
                item
                xs={4}
                style={{
                  display: "inline-grid",
                  justifyItems: "right",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  component="span"
                  style={{ fontWeight: 600, fontSize: "16px" }}
                >
                  <small>{unit.uom}</small>
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ marginTop: ".5em" }}>
                <TextField
                  autoComplete="off"
                  name="quantity"
                  type="number"
                  label="Quantity"
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={invoicedQuantity(unit)}
                  onChange={onOrderOrPriceInputOnChange(product, unit)}
                  InputLabelProps={{ shrink: true }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={4} style={{ marginTop: ".5em" }}>
                <TextField
                  autoComplete="off"
                  name="price"
                  type="number"
                  label="Price"
                  variant="outlined"
                  style={{ width: "100%" }}
                  onBlur={priceInputOnBlur(product, unit)}
                  value={priceWithTaxValue(unit)}
                  onChange={onOrderOrPriceInputOnChange(product, unit)}
                  InputLabelProps={{ shrink: true }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
            </Grid>
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
    );
  }

  function productElement(product) {
    return (
      <Grid container style={{ padding: "0px" }}>
        <Grid container item xs={12}>
          <Grid item xs={12} md={12} lg={12}>
            <Grid container direction="column" justifyContent="space-between" alignItems="stretch">
              <Grid
                item
                container
                onClick={() => {
                  setSelectedProductForLotNumberInput(product);
                  setOpenLotNumberAndExpirationDialogInput(true);
                }}
              >
                <Grid item xs container direction="column" justifyContent="center">
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.product_name}</Box>
                </Grid>
                <Grid item>
                  {/* <IconButton component="span" style={{ height: "100%" }} size="large">
                                        <MoreVertIcon />
                                    </IconButton> */}
                </Grid>
              </Grid>
              <Grid item>
                {product.Units != null &&
                  product.Units.map((unit) => (
                    <React.Fragment key={unit.id}>{orderInput(product, unit)}</React.Fragment>
                  ))}
              </Grid>
              {/* <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "red" }}>Available: {product.total_inventory_in_smallest_uom} {getProductSmallestUOM(product.Units)}</Grid>
                            <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>Total : P {product.total_invoiced_amount != null ? product.total_invoiced_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}</Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function invoicedQuantity(unit) {
    return unit.quantity_invoiced <= 0 ? "" : unit.quantity_invoiced;
  }

  function computeOverallTotalInvoiceAmount() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }
    const temporarySaleInvoiced = JSON.parse(temporarySalesInvoiceString);
    const overallTotalAmount = temporarySaleInvoiced
      .reduce(
        (partialSum, product) => partialSum + computeTotalInvoiceAmountPerProduct(product),
        0.0
      )
      .toFixed(2);

    return overallTotalAmount;
  }

  function computeTotalInvoiceAmountPerProduct(product) {
    const totalInvoiceValue = Number(
      product.Units.reduce((partialSum, unit) => {
        const amount = parseFloat(unit.quantity_invoiced) * unit.price_with_tax;
        return partialSum + (isNaN(amount) ? 0 : amount);
      }, 0.0)
    );
    return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue;
  }

  function totalInvoicedCount() {
    const totalProductUnitWithOrder = invoicedProducts.reduce((partialSum, product) => {
      const totalUnitWithQuantity = product.Units.reduce((unitWithQuantityPartialPrice, unit) => {
        const orderQuantity = unit.quantity_invoiced == null ? 0 : Number(unit.quantity_invoiced);

        if (!isNaN(orderQuantity) && orderQuantity > 0) {
          return unitWithQuantityPartialPrice + 1;
        }
        return unitWithQuantityPartialPrice;
      }, 0);
      return partialSum + totalUnitWithQuantity;
    }, 0);

    return totalProductUnitWithOrder;
  }

  const onOrderOrPriceInputOnChange = (product, unit) => (event) => {
    const productsCopy = [...invoicedProducts];

    if (event.target.name === "quantity") {
      const quantityInvoiced = Number(event.target.value);
      unit.quantity_invoiced =
        quantityInvoiced.length <= 0 || isNaN(quantityInvoiced)
          ? 0
          : parseFloat(quantityInvoiced).toFixed();
    } else if (event.target.name === "price") {
      const newPriceWithTax = Number(event.target.value);
      unit.price_with_tax =
        newPriceWithTax.length <= 0 || isNaN(newPriceWithTax)
          ? 0
          : parseFloat(newPriceWithTax).toFixed(2);
    }

    setTotalInvoicedAmount(computeTotalInvoiceAmount(productsCopy));
    setInvoicedItemCount(totalInvoicedCount());
    product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);

    setInvoicedProducts(productsCopy);
  };

  const computeTotalInvoiceAmount = (products) => {
    return products
      .reduce(
        (partialSum, product) => partialSum + computeTotalInvoiceAmountPerProduct(product),
        0.0
      )
      .toFixed(2);
  };

  const priceInputOnBlur = (product, unit) => (event) => {
    const currentPrice = unit.current_price_with_tax;
    const newPrice = unit.new_price_with_tax == null ? 0 : unit.new_price_with_tax;

    if (newPrice != null && newPrice.length > 0 && newPrice > 0) {
      return;
    }
    if (currentPrice == null) {
      return;
    }

    const productsCopy = [...invoicedProducts];
    unit.new_price_with_tax = currentPrice;

    // saveOrDeleteLocalStorageTempOrder(product)

    setTotalInvoicedAmount(computeTotalInvoiceAmount(productsCopy));
    setInvoicedItemCount(totalInvoicedCount());
    product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);

    setInvoicedProducts(productsCopy);
  };
  const clearInputClickListener = (event) => {
    localStorage.removeItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    props.closeThenOpenInputDialog();
  };
  function priceWithTaxValue(unit) {
    let price = 0;

    if (
      unit.price_with_tax == null ||
      unit.price_with_tax.length <= 0 ||
      parseFloat(unit.price_with_tax) <= 0
    ) {
      price = parseFloat(unit.price_with_tax);
    } else {
      price = parseFloat(unit.price_with_tax);
    }

    return price;
  }
  function getProductSmallestUOM(uoms) {
    if (uoms.length <= 0) {
      return "";
    }

    return uoms[0].uom;
  }
  function totalInvoicedQuantityInSmallestUOM(uoms) {
    return uoms
      .reduce(
        (partialSum, uom) =>
          partialSum +
          (uom.order_quantity == null ? 0 : uom.order_quantity * uom.converted_to_smallest_value),
        0.0
      )
      .toFixed(2);
  }

  return (
    <>
      <Dialog fullScreen open={props.openEditInvoiceDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={(e) => {
                e.stopPropagation();
                props.setOpenEditInvoiceDialog(false);
                props.setLoadData(true);
                props.setSelectedInvoices(null);
                props.setOrderMenuAnchorElement(null);
              }}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.title}>
              Transacti Sales Invoice <br />
              <small>{props.selectedInvoices ? props.selectedInvoices.account_name : ""}</small>
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <Paper square className={classes.productListPaper}>
          {productLists()}
        </Paper>
        <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
          <Toolbar>
            <Typography variant="subtitle1" noWrap>
              Total :{" "}
              {Number(totalInvoicedAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <div className={classes.grow} />

            <Button
              variant="contained"
              onClick={() => {
                const totalInvoicedItemCount = totalInvoicedCount();

                if (totalInvoicedItemCount <= 0) {
                  setMessageDialogMessage("Please input quantity and price atleast in one item.");
                  setShowMessageDialog(true);
                  return;
                }
                setOpenFinalizeProductDialog(true);
              }}
            >
              <Typography variant="caption" noWrap>
                Finalize Products
              </Typography>
              <Badge
                badgeContent={invoicedItemCount}
                color="secondary"
                style={{ marginLeft: "1rem" }}
              />
            </Button>
          </Toolbar>
        </AppBar>
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {/* {lotNumberAndExpirationInputDialog()}
                    {messageDialog()} */}

          {openFinalizeProductDialog && (
            <FinalizeEditedInvoices
              selectedInvoices={props.selectedInvoices}
              setSelectedInvoices={props.setSelectedInvoices}
              invoicedProducts={invoicedProducts}
              totalInvoicedAmount={totalInvoicedAmount}
              invoicedItemCount={invoicedItemCount}
              setOpenEditInvoiceDialog={props.setOpenEditInvoiceDialog}
              openFinalizeProductDialog={openFinalizeProductDialog}
              setOpenFinalizeProductDialog={setOpenFinalizeProductDialog}
              setOrderMenuAnchorElement={props.setOrderMenuAnchorElement}
              setLoadData={props.setLoadData}
            />
          )}
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
